import { getAuth } from 'firebase/auth';

/**
 * Fetch wrapper that attaches the Firebase ID token as a Bearer token.
 * Drop-in replacement for fetch() when calling the proxy server.
 */
export async function authenticatedFetch(url, options = {}) {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Not authenticated');

  const token = await user.getIdToken();
  return fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });
}
